
import React from 'react';
import LeafletMap from './LeafletMap';

interface MapComponentProps {
  latitude: number;
  longitude: number;
  zoom?: number;
  className?: string;
  category?: string;
  popupText?: string;
}

const MapComponent = ({ 
  latitude, 
  longitude, 
  zoom = 15, 
  className = "",
  category = 'default',
  popupText = 'Nossa localização'
}: MapComponentProps) => {
  try {
    return (
      <div className="relative">
        <LeafletMap 
          latitude={latitude} 
          longitude={longitude} 
          zoom={zoom} 
          className={className}
          category={category}
          popupText={popupText}
        />
      </div>
    );
  } catch (error) {
    console.error('Map component error:', error);
    return (
      <div className={`w-full h-40 rounded-xl bg-gray-100 flex items-center justify-center ${className}`}>
        <div className="text-gray-500 text-sm">Mapa não disponível no momento</div>
      </div>
    );
  }
};

export default MapComponent;
